import httpClient from '../lib/httpClient';
import config from '../config/origin';

const TOKEN_KEY = 'authToken';
const AUTH_FLAG = 'isAuthenticated';
const API_KEY = config.apiKey;

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(AUTH_FLAG, 'true');
};
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(AUTH_FLAG);
};
export const isAuthenticated = () => {
  return localStorage.getItem(AUTH_FLAG) === 'true' && !!getToken();
};

export const login = async (username, password) => {
  try {
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);

    const loginUrl = `${config.apiBaseUrl}/auth/token`;
    try {
      const resolvedLoginUrl = /^https?:\/\//.test(loginUrl)
        ? loginUrl
        : new URL(loginUrl, window.location.origin).toString();
      console.log('[NodeSpace] Login URL:', resolvedLoginUrl);
    } catch (_) {
      console.log('[NodeSpace] Login URL (raw):', loginUrl);
    }

    const res = await fetch(loginUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...(API_KEY ? { 'x-api-key': API_KEY, 'x-api-code': API_KEY } : {}),
      },
      body: formData.toString(),
      credentials: 'include',
    });

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      const err = new Error(errorData.detail || 'Credenciales inválidas');
      err.status = res.status;
      throw err;
    }

    const data = await res.json();
    if (data && data.access_token) {
      setToken(data.access_token);
      return { token: data.access_token, token_type: data.token_type };
    }

    throw new Error('Respuesta inválida del servidor');
  } catch (error) {
    clearToken();
    throw error;
  }
};

export const logout = async () => {
  try {
    await httpClient.post('auth/logout', {});
  } catch (_) {}
  clearToken();
};

const authServiceExport = { login, logout, getToken, setToken, clearToken, isAuthenticated };
export default authServiceExport;
